// extracted by mini-css-extract-plugin
export default {"container":"TablaCargaHoraria_container__Uqu1H","link":"TablaCargaHoraria_link__GbpJI","marginBottom":"TablaCargaHoraria_marginBottom__PYwHo"};